import { format } from 'd3-format';
import React, { Component } from 'react';
import { Element } from 'react-scroll';
import HorizontalScroll from 'react-scroll-horizontal';
import { images } from '../asset/image';
import { flags } from '../asset/image/flags';
import { storeBadge } from '../asset/image/store_badge';
import { getDateString, getStoreBadge } from '../global/Common';
import { exchange, getFullCurrencyString, getShortCurrencyString } from '../global/Currency';
import i18next from '../global/LocalizedStrings';
import { THEME } from '../global/Theme';
import './ResultScene.css';

const ColoredLine = ({ color, margin }) => (
    <div style={{ height: 1, backgroundColor: color, marginLeft: margin, marginRight: margin }} />
);

const CompanyInfoCard = ({ theme, title, value }) => (

    <div className="company-info-card"
        style={{
            backgroundColor: theme.cardBgColor,
            borderColor: theme.cardBorderColor,
        }}>
        <span style={{ textAlign: 'left', color: theme.textSecondaryColor }}>{title}</span>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            {
                title === i18next.t('result.country') ? (
                    <img src={flags[value.toLowerCase()]} style={{ width: '1.5em', height: '1.5em', marginRight: '0.5em' }} />
                ) : null
            }
            <div className="company-info-card-value" style={{ color: theme.textColor, textAlign: 'right' }}>{value}</div>
        </div>
    </div>
)

const ResultCard = ({ theme, color, title, value, subValue }) => {

    const v = typeof (value) === 'string' ? value : value.value
    const col = color ? color : theme.textColor

    return (
        <div className="company-info-card"
            style={{
                backgroundColor: theme.cardBgColor,
                borderColor: theme.cardBorderColor,
                flex: 1
            }}>
            <span style={{ textAlign: 'left', color: theme.textSecondaryColor }}>{title}</span>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div className="result-card-value" style={{ color: col, textAlign: 'left' }}>{v}</div>
                <div className="result-card-sub-value" style={{ color: theme.textSecondaryColor, textAlign: 'right' }}>{subValue}</div>
            </div>
        </div>
    )
}

const TransActionCard = ({ theme, buyData, sellData }) => {

    return (
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            {
                buyData ? (
                    <div className="company-info-card"
                        style={{
                            backgroundColor: theme.cardBgColor,
                            borderColor: theme.cardBorderColor,
                            flex: 1
                        }}>
                        <span style={{ textAlign: 'left', color: theme.textSecondaryColor }}>{buyData.date}</span>
                        <div className="company-info-card-value" style={{ color: buyData.style.color, textAlign: 'left', marginTop: '0.3em' }}>{buyData.title}</div>
                        <div className="result-card-sub-value" style={{ color: theme.textSecondaryColor, textAlign: 'left' }}>{buyData.dealInfo}</div>
                        <div className="result-card-value" style={{ color: buyData.style.color, textAlign: 'right' }}>{buyData.totalAmount}</div>
                        <div className="result-card-sub-value" style={{ color: theme.textSecondaryColor, textAlign: 'right' }}>{buyData.totalAmountFull}</div>
                        <span style={{ textAlign: 'left', color: theme.textSecondaryColor }}>{i18next.t('result.total')}</span>
                        <span style={{ textAlign: 'left', color: theme.textSecondaryColor }}>{buyData.assetFull}</span>
                    </div>
                ) : (
                    <div style={{ display: 'flex', flex: 1, margin: '4px', paddingTop: '1em', paddingBottom: '1em', justifyContent: 'center' }}>
                        <div style={{ width: '0.3em', height: '100%', backgroundColor: theme.lineColor }} />
                    </div>
                )
            }

            {
                sellData ? (
                    <div className="company-info-card"
                        style={{
                            backgroundColor: theme.cardBgColor,
                            borderColor: theme.cardBorderColor,
                            flex: 1
                        }}>
                        <span style={{ textAlign: 'left', color: theme.textSecondaryColor }}>{sellData.date}</span>
                        <div className="company-info-card-value" style={{ color: sellData.style.color, textAlign: 'left', marginTop: '0.3em' }}>{sellData.title}</div>
                        <div className="result-card-sub-value" style={{ color: theme.textSecondaryColor, textAlign: 'left' }}>{sellData.dealInfo}</div>
                        <div className="result-card-value" style={{ color: sellData.style.color, textAlign: 'right' }}>{sellData.totalAmount}</div>
                        <div className="result-card-sub-value" style={{ color: theme.textSecondaryColor, textAlign: 'right' }}>{sellData.totalAmountFull}</div>

                        <span style={{ textAlign: 'left', color: theme.textSecondaryColor }}>{i18next.t('result.total')}</span>
                        <span style={{ textAlign: 'left', color: theme.textSecondaryColor }}>{sellData.assetFull}</span>
                    </div>
                ) : (
                    <div style={{ display: 'flex', flex: 1, margin: '4px', paddingTop: '1em', paddingBottom: '1em', justifyContent: 'center' }}>
                        <div style={{ width: '0.3em', height: '100%', backgroundColor: theme.lineColor }} />
                    </div>
                )
            }
        </div>
    )
}

export class ResultScene extends Component {

    componentDidMount() {

    }

    _getCompanyInfo() {
        const { theme, companyInfo } = this.props;
        const name = companyInfo.getName()
        const usName = companyInfo.getUSName()
        const parent = { height: `6em` }

        return (
            <div>
                <div className="title" style={{ color: theme.textColor }}>{name}</div>
                <div className="sub-title" style={{ color: theme.textSecondaryColor }}>{usName}</div>
                <div style={parent}>
                    <HorizontalScroll style={{ display: 'flex' }}>
                        <CompanyInfoCard theme={theme} title={i18next.t('result.country')} value={companyInfo.country_code} />
                        <CompanyInfoCard theme={theme} title={i18next.t('result.exchange')} value={companyInfo.getExchange()} />
                        <CompanyInfoCard theme={theme} title={i18next.t('result.section')} value={companyInfo.getSection()} />
                        <CompanyInfoCard theme={theme} title={i18next.t('result.industry')} value={companyInfo.getIndustry()} />
                    </HorizontalScroll>
                </div>
            </div>
        )
    }

    _getInvestmentDuration() {
        const { tradeInfo, theme } = this.props;

        const startDate = tradeInfo.monkeyDealInfo.buyDate
        const endDate = tradeInfo.monkeyDealInfo.sellDate
        const period = getDateString(startDate.getTime()) + ' ~ ' + getDateString(endDate.getTime());

        return (
            <div>
                <div className="title" style={{ color: theme.textColor }}>{i18next.t('result.investmentPeriod')}</div>
                <div className="sub-title" style={{ color: theme.textSecondaryColor }}>{period}</div>
                <ColoredLine color={theme.lineColor} margin={'1em'} />
            </div>
        )
    }

    _getInvestmentResult(cells) {
        const { theme } = this.props;
        return (
            <div>
                <div className="title" style={{ color: theme.textColor, marginBottom: '1em' }}>{i18next.t('result.title')}</div>
                <div style={{ display: 'flex', marginBottom: '1em' }}>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', paddingLeft: '1em', alignItems: 'center' }}>
                            <img src={images.avatar} style={{ width: '2em', height: '2em' }} />
                            <span className="popup-title" style={{ marginLeft: '0.5em', color: theme.textColor }}>ME</span>
                        </div>

                        {cells.map(function (d) {
                            return (<ResultCard
                                key={d.title}
                                theme={theme}
                                title={i18next.t('result.' + d.title)}
                                value={d.data.me}
                                subValue={d.subData ? d.subData.me : ""}
                                color={d.color ? d.color.me : undefined} />)
                        })}

                    </div>

                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', paddingLeft: '1em', alignItems: 'center' }}>
                            <img src={images.monkey} style={{ width: '2em', height: '2em' }} />
                            <span className="popup-title" style={{ marginLeft: '0.5em', color: theme.textColor }}>MONKEY</span>
                        </div>

                        {cells.map(function (d) {
                            return (<ResultCard
                                key={d.title}
                                theme={theme}
                                title={i18next.t('result.' + d.title)}
                                value={d.data.monkey}
                                subValue={d.subData ? d.subData.monkey : ""}
                                color={d.color ? d.color.monkey : undefined}
                            />)
                        })}

                    </div>
                </div>
                <ColoredLine color={theme.lineColor} margin={'1em'} />
            </div>
        )
    }

    _getTransAction(cells) {
        const { theme } = this.props;

        return (
            <div>
                <div className="title" style={{ color: theme.textColor, marginBottom: '1em' }}>{i18next.t('result.transactionHistory')}</div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>

                    {cells.map(function (d) {
                        if (d.title) {
                            return (
                                <div key={d.title} style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div style={{ display: 'flex', flex: 1 }}>
                                        <ResultCard
                                            theme={theme}
                                            title={i18next.t('result.' + d.title)}
                                            value={d.data.me}
                                            subValue={d.subData ? d.subData.me : ""}
                                            color={d.color ? d.color.me : undefined} />
                                    </div>
                                    <div style={{ display: 'flex', flex: 1 }}>
                                        <ResultCard
                                            theme={theme}
                                            title={i18next.t('result.' + d.title)}
                                            value={d.data.monkey}
                                            subValue={d.subData ? d.subData.monkey : ""}
                                            color={d.color ? d.color.monkey : undefined} />
                                    </div>
                                </div>
                            )
                        }

                        return (
                            <div key={d.key} style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                                    <TransActionCard
                                        theme={theme}
                                        buyData={d.data.me.buyData}
                                        sellData={d.data.me.sellData}
                                    />
                                </div>
                                <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                                    <TransActionCard
                                        theme={theme}
                                        buyData={d.data.monkey.buyData}
                                        sellData={d.data.monkey.sellData}
                                    />
                                </div>
                            </div>

                        )
                    })}
                </div>

            </div>
        )
    }

    _getStoreBadge() {
        const { theme, width } = this.props;

        const appstoreSize = width > 450 ? 56 : 28
        const appstorePadding = width > 450 ? 12 : 6
        const playstoreSize = width > 450 ? 80 : 40

        return (
            <div style={{ marginTop: '0.5em' }}>
                <a href='https://itunes.apple.com/app/id1572464401'>
                    <img style={{ padding: appstorePadding }} height={appstoreSize} src={storeBadge[theme.themeName].appstore[i18next.getLanguage()]} />
                </a>
                <a href='https://play.google.com/store/apps/details?id=com.caminogames.traders'>
                    <img height={playstoreSize} src={storeBadge[theme.themeName].playstore[i18next.getLanguage()]} />
                </a>
            </div>

        )
    }

    render() {
        const { tradeInfo, nextInvest, theme, width } = this.props;

        if (!tradeInfo) {
            return null
        }

        const cellData = this.getCellData()

        return (
            <div style={{ backgroundColor: theme.backgroundColor, display: 'flex', flexDirection: 'column' }}>
                <div style={{ height: '3em', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: theme.naviBarColor }}>
                    <div className="popup-title" style={{ color: theme.textColor }}>{i18next.t('result.title')}</div>

                    <div
                        className="next-button"
                        style={{ color: theme.positiveColor }}
                        onClick={nextInvest}
                    >
                        {'NEXT'}
                    </div>
                </div>

                <ColoredLine color={theme.lineColor} margin={0} />

                <Element className="element" id="containerElement" style={{
                    position: 'relative',
                    height: '80vh',
                    overflow: 'scroll',
                }}>
                    {this._getCompanyInfo()}
                    {this._getInvestmentDuration()}
                    {getStoreBadge(theme, width)}
                    {this._getInvestmentResult(cellData.resultCell)}
                    {this._getTransAction(cellData.transActionCell)}
                    {getStoreBadge(theme, width)}
                </Element>
            </div>
        );
    }

    getCellData() {
        const { theme, tradeInfo } = this.props;

        const currency = i18next.getCurrency()
        let isRevenue = tradeInfo.isRevenue()
        let meDataColor = isRevenue.me === 0 ? theme.textColor : isRevenue.me === 1 ? THEME.getValuePositiveColor() : THEME.getValueNegativeColor();
        let monkeyDataColor = isRevenue.monkey === 0 ? theme.textColor : isRevenue.monkey === 1 ? THEME.getValuePositiveColor() : THEME.getValueNegativeColor();

        const resultCell = [
            {
                title: 'investment',
                data: tradeInfo.getInvestment(currency).short,
                subData: tradeInfo.getInvestment(currency).full,
            },
            {
                title: 'valuation',
                data: tradeInfo.getValuation(currency).short,
                subData: tradeInfo.getValuation(currency).full,
                color: {
                    me: meDataColor,
                    monkey: monkeyDataColor,
                }
            },
            {
                title: 'profit',
                data: tradeInfo.getProfit(currency).short,
                subData: tradeInfo.getProfit(currency).full,
                color: {
                    me: meDataColor,
                    monkey: monkeyDataColor,
                }
            },
            {
                title: 'yield',
                data: tradeInfo.getYield(),
                color: {
                    me: meDataColor,
                    monkey: monkeyDataColor,
                }
            },
            {
                title: 'numberOfTransaction',
                data: tradeInfo.getNumberOfTransaction()
            }
        ];

        let transActionCell = [
            {
                title: 'startAssets',
                data: tradeInfo.getStartAsset(currency).short,
                subData: tradeInfo.getStartAsset(currency).full,
            }
        ]

        if (tradeInfo.list == 0) {
            const tr = {
                key: '11',
                type: 'transaction_data',
                data: {
                    me: {},
                    monkey: this._getMonkeyTransActionData(tradeInfo)
                }
            }

            transActionCell.push(tr);

        } else {
            for (var idx in tradeInfo.list) {
                const data = tradeInfo.list[idx];

                const tr = {
                    key: '11' + idx.toString(),
                    type: 'transaction_data',
                    data: {
                        me: this._getMeTransActionData(data),
                        monkey: this._getMonkeyTransActionData(tradeInfo, idx)

                    }
                }

                transActionCell.push(tr);
            }
        }

        transActionCell.push({
            title: 'endAssets',
            data: tradeInfo.getEndAsset(currency).short,
            subData: tradeInfo.getEndAsset(currency).full,
        });

        return {
            resultCell,
            transActionCell
        }
    }

    _getMeTransActionData(data) {
        const { theme, tradeInfo } = this.props;
        const currency = i18next.getCurrency()

        let sellStyle

        if (data.buyPrice === data.sellPrice) {
            sellStyle = { color: theme.textColor }
        } else {
            if (data.type === "BUY") {
                sellStyle = data.buyPrice > data.sellPrice ? { color: THEME.getValueNegativeColor() } : { color: THEME.getValuePositiveColor() }
            } else {
                sellStyle = data.buyPrice < data.sellPrice ? { color: THEME.getValueNegativeColor() } : { color: THEME.getValuePositiveColor() }
            }
        }

        const sellAmount = data.type === "BUY" ? data.sellPrice * data.shareCount :
            (data.buyPrice * data.shareCount) + (data.buyPrice - data.sellPrice) * data.shareCount


        return {
            buyData: {
                date: getDateString(new Date(data.deals[0].date).getTime()),
                title: i18next.t(data.type.toLowerCase().toString()),
                totalAmount: getShortCurrencyString(exchange(data.buyPrice * data.shareCount, tradeInfo.stockCurrency), currency),
                totalAmountFull: getFullCurrencyString(exchange(data.buyPrice * data.shareCount, tradeInfo.stockCurrency), currency),
                dealInfo: i18next.t('result.dealInfo', { price: getFullCurrencyString(exchange(data.buyPrice, tradeInfo.stockCurrency), currency), shareCount: format(",.2r")(data.shareCount) }),
                asset: getShortCurrencyString(data.startBank + data.startStock, currency),
                assetFull: getFullCurrencyString(data.startBank + data.startStock, currency),
                style: { color: theme.textColor },
            },
            sellData: {
                date: getDateString(new Date(data.deals[1].date).getTime()),
                title: i18next.t(data.type == "BUY" ? 'sell' : 'corver'),
                totalAmount: getShortCurrencyString(exchange(sellAmount, tradeInfo.stockCurrency), currency),
                totalAmountFull: getFullCurrencyString(exchange(sellAmount, tradeInfo.stockCurrency), currency),
                dealInfo: i18next.t('result.dealInfo', { price: getFullCurrencyString(exchange(data.sellPrice, tradeInfo.stockCurrency), currency), shareCount: format(",.2r")(data.shareCount) }),
                asset: getShortCurrencyString(data.endBank + data.endStock, currency),
                assetFull: getFullCurrencyString(data.endBank + data.endStock, currency),
                style: sellStyle
            }
        }
    }

    _getMonkeyTransActionData(tradeInfo, idx) {

        const { theme } = this.props
        const currency = i18next.getCurrency()

        const monkeyAccount = tradeInfo.monkeyAccount
        const monkeyDealInfo = tradeInfo.monkeyDealInfo
        const length = idx == null ? 0 : tradeInfo.list.length

        const buyPrice = monkeyDealInfo.buyPrice
        const sellPrice = monkeyDealInfo.sellPrice
        const shareCount = monkeyDealInfo.shareCount

        return {
            buyData: idx == 0 || idx == null ? {
                date: getDateString(new Date(monkeyDealInfo.buyDate).getTime()),
                title: i18next.t('buy'),
                totalAmount: getShortCurrencyString(exchange(buyPrice * shareCount, tradeInfo.stockCurrency), currency),
                totalAmountFull: getFullCurrencyString(exchange(buyPrice * shareCount, tradeInfo.stockCurrency), currency),
                dealInfo: i18next.t('result.dealInfo', { price: getFullCurrencyString(exchange(buyPrice, tradeInfo.stockCurrency), currency), shareCount: format(",.2r")(shareCount) }),
                asset: getShortCurrencyString(monkeyAccount.start.bank + monkeyAccount.start.stock, currency),
                assetFull: getFullCurrencyString(monkeyAccount.start.bank + monkeyAccount.start.stock, currency),
                style: { color: theme.textColor },
            } : null,

            sellData: idx == length - 1 || idx == null ? {
                date: getDateString(new Date(monkeyDealInfo.sellDate).getTime()),
                title: i18next.t('sell'),
                totalAmount: getShortCurrencyString(exchange(sellPrice * shareCount, tradeInfo.stockCurrency), currency),
                totalAmountFull: getFullCurrencyString(exchange(sellPrice * shareCount, tradeInfo.stockCurrency), currency),
                dealInfo: i18next.t('result.dealInfo', { price: getFullCurrencyString(exchange(sellPrice, tradeInfo.stockCurrency), currency), shareCount: format(",.2r")(shareCount) }),
                asset: getShortCurrencyString(monkeyAccount.start.bank + tradeInfo.getMonkeyValuation(), currency),
                assetFull: getFullCurrencyString(monkeyAccount.start.bank + tradeInfo.getMonkeyValuation(), currency),
                style: buyPrice == sellPrice ? { color: theme.textColor } : buyPrice > sellPrice ? { color: THEME.getValueNegativeColor() } : { color: THEME.getValuePositiveColor() }

            } : null
        }
    }
}